/**
 * Base form path for a content section. Blueprint `content` is an array, so
 * react-hook-form field names must use the section index (e.g. content.0, content.1),
 * not formLabel. Use this helper so all section views share one convention.
 */
export const contentSectionFormPath = (contentIndex: number): string =>
  `content.${contentIndex}`;

/** Form path prefix for advisor content (e.g. for edited-tab detection). */
export const ADVISOR_CONTENT_FORM_PREFIX = "advisorContent.";

/** Base form path for an advisor section (e.g. advisorContent.summary). */
export const advisorSectionFormPath = (sectionKey: string): string =>
  `advisorContent.${sectionKey}`;

/** Full form path for an advisor section field (e.g. advisorContent.summary.text). */
export const advisorSectionFieldPath = (
  sectionKey: string,
  fieldKey: string,
): string => `${advisorSectionFormPath(sectionKey)}.${fieldKey}`;

/** Stable id for an advisor form field (e.g. advisorContent-summary-text). */
export const advisorFieldId = (sectionKey: string, fieldKey: string): string =>
  `advisorContent-${sectionKey}-${fieldKey}`;
